import { useFetchCurrentOrders } from 'api/queries/useFetchNextOrders'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Loader } from 'features/components/Loader'
import { EmptyStateOrder } from 'features/EmptyStates/components/EmptyStateOrder'
import { useTranslation } from 'hooks/useTranslation'
import { UserLayout } from '../components/UserLayout'
import { UserLayoutCard } from '../components/UserLayout/UserLayout.styles'
import { OrderOverview } from './components/OrderOverview'
import { useFetchClient } from '../../../api/queries/useFetchClient'

export const MyAccount = () => {
  const { t } = useTranslation()

  const { data: orders, status: ordersStatus } = useFetchCurrentOrders()

  const { data: client } = useFetchClient()

  if (ordersStatus === 'loading') return <Loader />

  return (
    <UserLayout title="dashboard:title" description="dashboard:description" client={client}>
      <UserLayoutCard>
        <Stack direction="column" gap="2" css={{ height: '100%' }}>
          <Stack direction="column">
            <Text as="h2" size="h4" weight="medium" display="block">
              {t('dashboard:current-orders.title')}
            </Text>
            <Text>{t('dashboard:current-orders.description')}</Text>
          </Stack>
          {orders && orders?.orders.length !== 0 ? (
            <Stack direction="column" gap="3">
              {orders.orders.map((order, index) => {
                return <OrderOverview key={order.orderId} order={order} />
              })}
            </Stack>
          ) : (
            <Stack justifyContent="center" css={{ py: '$12', height: '100%' }}>
              <EmptyStateOrder />
            </Stack>
          )}
        </Stack>
      </UserLayoutCard>
    </UserLayout>
  )
}

MyAccount.displayName = 'MyAccount'
